import ModelValidator from '@/validator/Validator';

import ControlValidator from './CustomValidator';

class FormGroupValidator {
  public static buildValidator<T = unknown>(modelValidator: ModelValidator): ControlValidator<T> {
    return async (value) => {
      await modelValidator.validateAll(value);
      return modelValidator.messageBag.hasErrors() ? modelValidator.messageBag.errors.messages : null;
    };
  }
}

export default FormGroupValidator;
